"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsorshipsService = void 0;
class SponsorshipsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get list of sponsorships for a creator
     * @param legacyChanneld
     * @param acceptLanguage
     * @param state
     * @returns SponsorshipsResponse
     * @throws ApiError
     */
    getInternalSponsorships(legacyChanneld, acceptLanguage, state) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/sponsorships/{legacyChanneld}',
            path: {
                'legacyChanneld': legacyChanneld,
            },
            headers: {
                'accept-language': acceptLanguage,
            },
            query: {
                'state': state,
            },
        });
    }
    /**
     * Get list of sponsorships for a creator
     * @param acceptLanguage
     * @param states
     * @param platforms
     * @returns SponsorshipsResponse
     * @throws ApiError
     */
    getSponsorships(acceptLanguage, states, platforms) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships',
            headers: {
                'accept-language': acceptLanguage,
            },
            query: {
                'states': states,
                'platforms': platforms,
            },
        });
    }
    /**
     * Get list of sponsorships for a creator V2
     * @param state
     * @param acceptLanguage
     * @param page
     * @param count
     * @param platform
     * @returns SponsorshipsResponse
     * @throws ApiError
     */
    getSponsorshipsV2(state, acceptLanguage, page, count, platform) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/sponsorships',
            headers: {
                'accept-language': acceptLanguage,
            },
            query: {
                'state': state,
                'page': page,
                'count': count,
                'platform': platform,
            },
        });
    }
    /**
     * Get payment url by type
     * @param type
     * @returns PaymentURLResponse
     * @throws ApiError
     */
    getPaymentUrl(type) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/payment/url',
            query: {
                'type': type,
            },
        });
    }
    /**
     * Get payment info for a sponsorship
     * @param id
     * @returns PayeeOnboardingResponse
     * @throws ApiError
     */
    getPaymentInfo(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/payment',
            query: {
                'id': id,
            },
        });
    }
    /**
     * Check with payout system is payment is set up for the creator
     * @returns PayeeOnboardingStatus
     * @throws ApiError
     */
    isPaymentSetup() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/is-payment-setup',
        });
    }
    /**
     * Complete deployment for a creator
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    completeOffer(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/complete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * start sponsorship for a creator
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    startOffer(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/start',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Start preview based on a group for a creator, making it a deployment
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    startPreview(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/start-preview',
            path: {
                'id': id,
            },
        });
    }
    /**
     * update manual deployment with start interest
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateManualDeploymentWithStartInterest(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/start-interest',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * undo manual deployment start interest
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    undoStartInterest(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/undo-start-interest',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Accept sponsorships for a creator
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    acceptOffer(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/accept',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Accept preview based on a group for a creator, making it a deployment
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    acceptPreview(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/accept-preview',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Reject sponsorships for a creator
     * @param id
     * @param requestBody RejectOfferPayload
     * @returns any Successful response
     * @throws ApiError
     */
    rejectOffer(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reject sponsorships preview for a creator
     * @param id
     * @param requestBody RejectOfferPayload
     * @returns any Successful response
     * @throws ApiError
     */
    rejectPreview(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/reject-preview',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Rejection reasons for creators
     * @returns DeploymentRejectReasons
     * @throws ApiError
     */
    getSponsorshipRejectionReasons() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/rejection-reasons',
        });
    }
    /**
     * Schedule sponsorships start date
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    scheduleSponsorship(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{id}/schedule',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get list of sponsorship deliverables for a creator
     * @param id
     * @returns SponsorshipDeliverablesResponse
     * @throws ApiError
     */
    getDeliverables(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/{id}/deliverables',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Execute action for a sponsorship deliverable
     * @param deploymentId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    executeAction(deploymentId, id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{deploymentId}/deliverables/{id}/execute',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Execute action for a sponsorship deliverable with result
     * @param deploymentId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    executeActionWithResult(deploymentId, id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{deploymentId}/deliverables/{id}/executeWithResult',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update deliverable progress manually
     * @param deploymentId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateGoalProgress(deploymentId, id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{deploymentId}/deliverables/{id}/goalProgress',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Change the deployment state from outreached to viewed
     * @param deploymentId
     * @returns any Successful response
     * @throws ApiError
     */
    viewDeployment(deploymentId) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/sponsorships/{deploymentId}/viewed',
            path: {
                'deploymentId': deploymentId,
            },
        });
    }
    /**
     * Mark the preview sponsorship as viewed
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    viewPreview(id) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/sponsorships-preview/{id}/viewed',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get intents for sponsorship across all deployments
     * @returns CreatorIntentListResponse
     * @throws ApiError
     */
    listCreatorIntents() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/intents',
        });
    }
    /**
     * Create user intent
     * @param requestBody CreatorIntentCreateInput
     * @returns CreatorIntentResponse
     * @throws ApiError
     */
    createCreatorIntent(requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/sponsorships/intents',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get sponsorship by id
     * @param id
     * @param acceptLanguage
     * @returns SponsorshipResponse
     * @throws ApiError
     */
    getSponsorshipById(id, acceptLanguage) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/{id}',
            path: {
                'id': id,
            },
            headers: {
                'accept-language': acceptLanguage,
            },
        });
    }
    /**
     * Get sponsorship preview by id
     * @param id
     * @param acceptLanguage
     * @returns SponsorshipResponse
     * @throws ApiError
     */
    getSponsorshipPreviewById(id, acceptLanguage) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships-preview/{id}',
            path: {
                'id': id,
            },
            headers: {
                'accept-language': acceptLanguage,
            },
        });
    }
    /**
     * Get list of sponsorship preview deliverables for a creator
     * @param id
     * @returns SponsorshipDeliverablesResponse
     * @throws ApiError
     */
    getPreviewDeliverables(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships-preview/{id}/deliverables',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Remove user intent
     * @param id
     * @returns CreatorIntentRemoveResponse
     * @throws ApiError
     */
    removeCreatorIntent(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/sponsorships/intents/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get contract signed url
     * @param deploymentId
     * @returns GetFileSignedUrlResponse
     * @throws ApiError
     */
    generateContractSignedUrl(deploymentId) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{deploymentId}/contract',
            path: {
                'deploymentId': deploymentId,
            },
        });
    }
    /**
     * Check youtube permissions scopes
     * @param deploymentId
     * @returns HasScopesResponse
     * @throws ApiError
     */
    checkYouTubePermissions(deploymentId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/{deploymentId}/youtube/permissions',
            path: {
                'deploymentId': deploymentId,
            },
        });
    }
    /**
     * Get public sponsorship by id
     * @param id
     * @param acceptLanguage
     * @returns PublicSponsorshipResponse
     * @throws ApiError
     */
    getPublicSponsorshipById(id, acceptLanguage) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/public/{id}',
            path: {
                'id': id,
            },
            headers: {
                'accept-language': acceptLanguage,
            },
        });
    }
    /**
     * Get public sponsorships by channel id
     * @param channel
     * @param acceptLanguage
     * @returns PublicSponsorshipsResponse
     * @throws ApiError
     */
    getPublicSponsorshipsByChannelId(channel, acceptLanguage) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/public/{channel}/list',
            path: {
                'channel': channel,
            },
            headers: {
                'accept-language': acceptLanguage,
            },
        });
    }
    /**
     * Get list of sponsorship deliverables for a creator by public id
     * @param id
     * @returns SponsorshipDeliverablesResponse
     * @throws ApiError
     */
    getPublicDeliverables(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/public/{id}/deliverables',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get sponsorship by public id
     * @param id
     * @returns SponsorshipResponse
     * @throws ApiError
     */
    getSponsorshipByPublicId(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/{id}/public',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Change the deployment state to viewed
     * @param publicDeploymentId
     * @returns any Successful response
     * @throws ApiError
     */
    viewPublicDeployment(publicDeploymentId) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/sponsorships/{publicDeploymentId}/public-viewed',
            path: {
                'publicDeploymentId': publicDeploymentId,
            },
        });
    }
    /**
     * Get sponsorship creator feedback
     * @param sponsorshipId
     * @returns SponsorshipCreatorFeedback
     * @throws ApiError
     */
    getSponsorshipCreatorFeedback(sponsorshipId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/{sponsorshipId}/feedback',
            path: {
                'sponsorshipId': sponsorshipId,
            },
        });
    }
    /**
     * Creator sponsorship creator feedback
     * @param sponsorshipId
     * @param requestBody
     * @returns SponsorshipCreatorFeedback
     * @throws ApiError
     */
    createSponsorshipCreatorFeedback(sponsorshipId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sponsorships/{sponsorshipId}/feedback',
            path: {
                'sponsorshipId': sponsorshipId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upsert sponsorship creator feedback
     * @param sponsorshipId
     * @param requestBody
     * @returns SponsorshipCreatorFeedback
     * @throws ApiError
     */
    upsertSponsorshipCreatorFeedback(sponsorshipId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/sponsorships/{sponsorshipId}/feedback',
            path: {
                'sponsorshipId': sponsorshipId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get blocked advertisers
     * @returns BlockedAdvertisersResponse
     * @throws ApiError
     */
    getBlockedAdvertisers() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/advertisers/blocked',
        });
    }
    /**
     * Unassign a creator from an agency by the creator
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAgencyCreatorByCreator(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/sponsorships/agency/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get creator starred/preferred email by deployment public id
     * @param id
     * @returns SponsorshipsCreatorResponse
     * @throws ApiError
     */
    getCreatorEmailByPublicDeploymentId(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sponsorships/creator-email/{id}',
            path: {
                'id': id,
            },
        });
    }
}
exports.SponsorshipsService = SponsorshipsService;
